import { Permission, notEqual } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { Role, useRolesTableContext } from '../../../../../../RolesTableContext'
import {
  EditRoleModalBody,
  EditRoleModalValues,
} from './components/EditRoleModalBody'
import { useEditRoleMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'

export function useEditOptions(): EditRowActionOptions<
  Role,
  EditRoleModalValues
> {
  const { refetch } = useRolesTableContext()
  const [editRole] = useEditRoleMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editRole: {
        role: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditRole,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <EditRoleModalBody />,
      initialValues: ({ name, description, permissions }) => {
        return { name, description, permissionIds: permissions }
      },
      onOk: async (
        { id, name: prevName, description: prevDescription, permissions },
        { name, description, permissionIds }
      ) => {
        if (
          prevName !== name ||
          prevDescription !== description ||
          notEqual(permissions, permissionIds)
        ) {
          await editRole({
            variables: {
              editRoleInput: { id, name, description, permissionIds },
            },
          })
          await refetch()
        }
      },
    },
  }
}
